import axios from 'axios';
import api from './api';

export function getPOLinkedBinList(data) {
  return api.get(`/tva/v1/sorting/linked-bin?factory_code=${data.factory_code}&po_codes=${data.po_codes}`)
}

export function getPanelList(data) {
  return api.get(`/tva/v1/sorting/panels/${data.po_code}?factory_code=${data.factory_code}&po_code=${data.po_code}&location=${data.location}&sorted_panels=${data.sorted_panels}`)
}

export function assignBinToPO(data) {
  return api.post(`/tva/v1/sorting/linked-bin?factory_code=${data.factory_code}`, JSON.stringify(data))
}

export function addPanelToBin(data) {
  return api.post(`/tva/v1/sorting/panels?factory_code=${data.factory_code}`, JSON.stringify(data))
}

export function getPOList(data) {
  return api.post(`/tva/v1/projects/get-project-list?factory_code=${data.factory_code}`, JSON.stringify(data))
}

export function raiseQCRequest(data) {
  return api.post(`/tva/v1/qc-request/${data.po_code}?factory_code=${data.factory_code}`, JSON.stringify(data))
}

export function getQCRequests(data) {
  return api.get(`/tva/v1/qc-request?po_code=${data.po_code}&factory_code=${data.factory_code}`, JSON.stringify(data))
}

export function updatePanelStatus(data) {
  return api.put(`/tva/v1/sorting/panels/${data.po_code}?factory_code=${data.factory_code}`, JSON.stringify(data.payload))
}

export function updateQCRequest(data) {
  return api.put(`/tva/v1/qc-request/${data.po_code}?factory_code=${data.factory_code}&status=${data.status}`, JSON.stringify({}))
}

export function fetchImageList(po_code) {
  return api.get(`/tva/v1/qc/images/${po_code}`)
}

export function getPresignedUrl(data) {
  return api.get(`/tva/v1/qc/images/presigned-url?po_code=${data.po_code}&images=${data.imageList.join(',')}`)
}

export function uploadImagesToAWS(data) {
  return axios.put(data.presignedUrl, data.payload)
}

export function uploadImagesToTVA(data) {
  return api.put(`/tva/v1/qc/images/${data.po_code}?images=${data.imageList.join(',')}`)
}

export function deleteImages(data) {
  return api.remove(`/tva/v1/qc/images/${data.po_code}?images=${data.imageList.join(',')}`)
}

export function getRejectionList() {
  return api.get(`rejectionReasons.json`, {baseURL: '/'});
}

export function fetchImosCsv(po_code) {
  return api.get(`/tva/v1/reports/imos-csv-download/${po_code}`)
}